import type { Token } from "@0xsquid/squid-types";
import {
  TOKEN_2022_PROGRAM_ID,
  TOKEN_PROGRAM_ID,
} from "@solana/spl-token";
import { Connection, PublicKey } from "@solana/web3.js";

export const solanaTokenProgramIds = [
  TOKEN_PROGRAM_ID,
  TOKEN_2022_PROGRAM_ID,
] as const;

const solanaTokenProgramIdByAddress: Record<string, PublicKey> = {
  [TOKEN_PROGRAM_ID.toBase58()]: TOKEN_PROGRAM_ID,
  [TOKEN_2022_PROGRAM_ID.toBase58()]: TOKEN_2022_PROGRAM_ID,
};

export const isSupportedSolanaTokenProgramId = (
  programId: PublicKey
): boolean => programId.toBase58() in solanaTokenProgramIdByAddress;

export const getSupportedSolanaTokenProgramId = (
  tokenProgramId?: string
): PublicKey | undefined => {
  if (!tokenProgramId) return undefined;

  return solanaTokenProgramIdByAddress[tokenProgramId];
};

export const resolveSolanaTokenProgramId = async ({
  connection,
  token,
}: {
  connection: Connection;
  token: Token;
}): Promise<PublicKey> => {
  const tokenProgramId = getSupportedSolanaTokenProgramId(token.tokenProgramId);
  if (tokenProgramId) {
    return tokenProgramId;
  }

  const mint = new PublicKey(token.address);
  const mintAccount = await connection.getAccountInfo(mint);

  if (!mintAccount) {
    throw new Error(`Solana mint account not found: ${token.address}`);
  }

  if (!isSupportedSolanaTokenProgramId(mintAccount.owner)) {
    throw new Error(
      `Unsupported Solana token program for mint ${token.address}: ${mintAccount.owner.toBase58()}`
    );
  }

  return mintAccount.owner;
};
